import React from 'react';
import './styles.scss';
// import logo from '../../images/slogo-azul-branco.png';
import AuthContext from '../../auth/index';

import { BaSeAccountProfile } from '@base/react';

const Cabecalho = () => {


  return (
    <AuthContext.Consumer>
      {({ keycloak }) => (
        <header className="main-header-container-logo">

          <div className="areaLeft-container-logo">
            {/* MobileIcon */}
            <svg
              width="40"
              height="50"
              viewBox="0 0 40 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="logo"
            >
              <path
                d="M13.6598 6.82992C13.6598 7.36898 13.2226 7.80535 12.6844 7.80535C12.1454 7.80535 11.709 7.36806 11.709 6.82992C11.709 6.29087 12.1463 5.85449 12.6844 5.85449C13.2235 5.85449 13.6598 6.29179 13.6598 6.82992Z"
                fill="white"
              />
              <path
                d="M16.5861 43.1239C16.5861 42.5848 16.1488 42.1484 15.6107 42.1484H9.75717C9.21812 42.1484 8.78174 42.5857 8.78174 43.1239C8.78174 43.6629 9.21903 44.0993 9.75717 44.0993H15.6107C16.1497 44.0993 16.5861 43.662 16.5861 43.1239Z"
                fill="white"
              />
              <path
                d="M13.6598 48.9764C13.6598 49.5155 13.2226 49.9518 12.6844 49.9518C12.1454 49.9518 11.709 49.5145 11.709 48.9764C11.709 48.4373 12.1463 48.001 12.6844 48.001C13.2235 48.001 13.6598 48.4383 13.6598 48.9764Z"
                fill="white"
              />
              <path
                d="M21.4641 0.000916758H3.90264C1.75101 0.000916758 0 1.75192 0 3.90356V46.0506C0 48.2022 1.75009 49.9532 3.90264 49.9532H8.293C8.83205 49.9532 9.26843 49.5159 9.26843 48.9778C9.26843 48.4388 8.83113 48.0024 8.293 48.0024H3.90264C2.82728 48.0024 1.95178 47.1269 1.95178 46.0515V3.90447C1.95178 2.82912 2.82728 1.95361 3.90264 1.95361H21.4641C22.5403 1.95361 23.4158 2.82912 23.4158 3.90447V9.97983C18.2087 11.6575 14.6351 16.5163 14.6351 22.0508C14.6351 24.2648 15.2329 26.4494 16.3687 28.3984L14.6846 33.4498C14.5682 33.8009 14.6599 34.1868 14.9202 34.4481C15.1815 34.7094 15.5684 34.8001 15.9186 34.6837L20.9699 32.9996C21.7501 33.4553 22.5697 33.8238 23.4149 34.1025V46.0506C23.4149 47.126 22.5394 48.0015 21.4631 48.0015H17.0728C16.5337 48.0015 16.0974 48.4388 16.0974 48.9769C16.0974 49.5159 16.5347 49.9523 17.0728 49.9523H21.4631C23.6148 49.9523 25.3658 48.2022 25.3658 46.0497V34.5774C26.0103 34.6801 26.6639 34.7323 27.3166 34.7323C34.3097 34.7323 40 29.0429 40 22.0499C40 15.0568 34.3106 9.36652 27.3166 9.36652C26.6612 9.36652 26.0075 9.41694 25.3658 9.51595V3.90264C25.3658 1.75101 23.6148 0 21.4631 0L21.4641 0.000916758ZM27.3176 11.3183C33.2352 11.3183 38.0491 16.1322 38.0491 22.0499C38.0491 27.9675 33.2352 32.7814 27.3176 32.7814C25.2805 32.7814 23.326 32.1901 21.6107 31.1065C21.3641 30.9498 21.0589 30.9131 20.782 31.0057L17.1525 32.2149L18.3618 28.5854C18.4543 28.3077 18.4168 28.0033 18.2609 27.7558C17.1645 26.0204 16.586 24.0475 16.586 22.0499C16.586 16.1404 21.3614 11.3183 27.3176 11.3183Z"
                fill="white"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.8744 18.085H34.7523L34.1802 20.7142H20.3032L20.8744 18.085Z"
                fill="#00CCFF"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.042 22.2148H33.9181L33.3469 24.845H19.47L20.042 22.2148Z"
                fill="#00CCFF"
              />
            </svg>
            <span className="painel-text">
              Painel Administrativo do App Sebrae
            </span>
          </div>

          <div className="areaRight-container-user">
            <BaSeAccountProfile keycloak={keycloak}  />
          </div>
        </header>
      )}
    </AuthContext.Consumer>
  );
};

export default Cabecalho;
